export default "__VITE_ASSET__D4dS4NjB__"